import { Button, DatePicker, Input, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { PrintCyclenderInput } from "../../../common/common-functions";
import { useParams } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import AlramInput from "../../../../components/AlramInput";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

const MainEngineLog = () => {
  const user = useUserData();
  const { selectedDate } = useDate();
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [cyl_exhaust_temp_for_main, set_cyl_exhaust_temp_for_main] = useState(
    []
  );
  const [cyl_scavenge_box_temp_for_main, set_cyl_scavenge_box_temp_for_main] =
    useState("");
  const [cyl_jacket_water_temp_for_main, set_cyl_jacket_water_temp_for_main] =
    useState("");
  const [
    cyl_piston_cooling_oil_out_temp_for_main,
    set_cyl_piston_cooling_oil_out_temp_for_main,
  ] = useState("");
  const [cyl_fuel_rack_for_main, set_cyl_fuel_rack_for_main] = useState("");
  const [fuel_Oil_Type, set_Fuel_Oil_Type] = useState("");
  const [other_fuel_oil_type, set_Other_fuel_oil_type] = useState("");
  const [fuel_index, set_fuel_index] = useState("");
  const [govenor, set_govenor] = useState("");
  const [fuel_oil_inlet, set_fuel_oil_inlet] = useState("");
  const [fuel_oil_inlet_temp, set_fuel_oil_inlet_temp] = useState("");
  const [pressure, set_pressure] = useState("");
  const [starting_air_pressure, set_starting_air_pressure] = useState("");
  const [control_air_pressure, set_control_air_pressure] = useState("");
  const [scavenge_air_inlet_temp, set_scavenge_air_inlet_temp] = useState("");
  const [scavenge_air_pressure, set_scavenge_air_pressure] = useState("");
  const [egb_inlet_temp, set_egb_inlet_temp] = useState("");
  const [egb_outlet_temp, set_egb_outlet_temp] = useState("");
  const [rpm_X_1000, set_Rpm_X_1000] = useState("");
  const [exhaust_in_temp, set_exhaust_in_temp] = useState("");
  const [exhaust_out_temp, set_exhaust_out_temp] = useState("");
  const [air_In, set_Air_In] = useState("");
  const [air_Out, set_Air_Out] = useState("");
  const [lube_oil_in_temp, set_lube_oil_in_temp] = useState("");
  const [lube_oil_out_temp, set_lube_oil_out_temp] = useState("");
  const [lube_oil_in_pressure, set_lube_oil_in_pressure] = useState("");
  const [lube_oil_out_pressure, set_lube_oil_out_pressure] = useState("");
  const [lo_cooling_water_in_temp, set_lo_cooling_water_in_temp] = useState("");
  const [lo_cooling_water_in_pressure, set_lo_cooling_water_in_pressure] =
    useState("");
  const [
    lo_cooler_cooling_water_out_temp,
    set_lo_cooler_cooling_water_out_temp,
  ] = useState("");
  const [
    lo_cooler_cooling_water_out_pressure,
    set_lo_cooler_cooling_water_out_pressure,
  ] = useState("");
  const [lube_oil_inlet_to_engine, set_lube_oil_inlet_to_engine] = useState("");
  const [lube_oil_inlet_to_tc, set_lube_oil_inlet_to_tc] = useState("");
  const [lube_oil_inlet_temp, set_lube_oil_inlet_temp] = useState("");
  const [air_cooler_air_in_temp, set_air_cooler_air_in_temp] = useState("");
  const [air_cooler_air_out_temp, set_air_cooler_air_out_temp] = useState("");
  const [ac_cooling_water_in_temp, set_ac_cooling_water_in_temp] = useState("");
  const [ac_cooling_water_out_temp, set_ac_cooling_water_out_temp] =
    useState("");
  const [ac_cooling_water_in_pressure, set_ac_cooling_water_in_pressure] =
    useState("");
  const [ac_cooling_water_out_pressure, set_ac_cooling_water_out_pressure] =
    useState("");
  const [ac_air_in_pressure, set_ac_air_in_pressure] = useState("");
  const [ac_air_out_pressure, set_ac_air_out_pressure] = useState("");
  const [ac_manometer_pressure, set_ac_manometer_pressure] = useState("");
  const [lt_sea_water_in_temp, set_lt_sea_water_in_temp] = useState("");
  const [lt_sea_water_out_temp, set_lt_sea_water_out_temp] = useState("");
  const [lt_sea_water_in_pressure, set_lt_sea_water_in_pressure] = useState("");
  const [lt_sea_water_out_pressure, set_lt_sea_water_out_pressure] =
    useState("");
  const [lt_fresh_water_in_temp, set_lt_fresh_water_in_temp] = useState("");
  const [lt_fresh_water_out_temp, set_lt_fresh_water_out_temp] = useState("");
  const [lt_fresh_water_in_pressure, set_lt_fresh_water_in_pressure] =
    useState("");
  const [lt_fresh_water_out_pressure, set_lt_fresh_water_out_pressure] =
    useState("");
  const [ship_no_of_cylinder, set_ship_no_of_cylinder] = useState(null);
  const [main_engine_number, set_main_engine_number] = useState(1);
  const [engine_number_list, set_engine_number_list] = useState([]);
  const [cooling_water_inlet, set_cooling_water_inlet] = useState("");
  const [lube_Oil_Inlet, set_Lube_Oil_Inlet] = useState("");
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [cyl_oil_bn, set_cyl_oil_bn] = useState("");
  const [turbocharger_on_off, set_turbocharger_on_off] = useState(false);
  const [exhaust_in_temp_two, set_exhaust_in_temp_two] = useState("");
  const [exhaust_out_temp_two, set_exhaust_out_temp_two] = useState("");
  const [rpm_X_1000_two, set_Rpm_X_1000_two] = useState("");
  const [air_In_two, set_Air_In_two] = useState("");
  const [air_Out_two, set_Air_Out_two] = useState("");
  const [lube_oil_inlet_to_tc_two, set_lube_oil_inlet_to_tc_two] = useState("");

  // Alarm state change
  const [main_exhaust_temp, set_main_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_box_temp, set_scavenge_box_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [jacket_water_temp, set_jacket_water_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });

  const [piston_cooling_oil_out_temp, set_piston_cooling_oil_out_temp] =
    useState({
      max: null,
      orange: null,
      red: null,
    });

  const [fuel_rack, set_fuel_rack] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_alarm, set_fuel_oil_inlet_alarm] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_air_inlet, set_scavenge_air_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [lube_oil_inlet, set_lube_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_inlet, set_egb_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_outlet, set_egb_outlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [exh_in, set_exh_in] = useState({ max: null, orange: null, red: null });
  const [exh_out, set_exh_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_in, set_air_in] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_out, set_air_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_to_engine, set_fuel_oil_inlet_to_engine] = useState({
    max: null,
    orange: null,
    red: null,
  });

  // Alarm Api
  const ALARM_VIEW_API = async () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.view_alarm_conditions_st, FORM_DATA).then((res) => {
        const alarm_condition_data = res?.alarm_condition_data;
        if (res?.status == true && alarm_condition_data) {
          set_main_exhaust_temp(
            JSON.parse(alarm_condition_data.main_exhaust_temp)
          );
          set_scavenge_box_temp(
            JSON.parse(alarm_condition_data.scavenge_box_temp)
          );
          set_jacket_water_temp(
            JSON.parse(alarm_condition_data.jacket_water_temp)
          );
          set_piston_cooling_oil_out_temp(
            JSON.parse(alarm_condition_data.piston_cooling_oil_out_temp)
          );
          set_fuel_rack(JSON.parse(alarm_condition_data.fuel_rack));
          set_fuel_oil_inlet_alarm(
            JSON.parse(alarm_condition_data.fuel_oil_inlet)
          );
          set_scavenge_air_inlet(
            JSON.parse(alarm_condition_data.scavenge_air_inlet)
          );
          set_lube_oil_inlet(JSON.parse(alarm_condition_data.lube_oil_inlet));
          set_egb_inlet(JSON.parse(alarm_condition_data.egb_inlet));
          set_egb_outlet(JSON.parse(alarm_condition_data.egb_outlet));
          set_exh_in(JSON.parse(alarm_condition_data.exh_in));
          set_exh_out(JSON.parse(alarm_condition_data.exh_out));
          set_air_in(JSON.parse(alarm_condition_data.air_in));
          set_air_out(JSON.parse(alarm_condition_data.air_out));
          set_fuel_oil_inlet_to_engine(
            JSON.parse(alarm_condition_data.fuel_oil_inlet_to_engine)
          );
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  };

  const ADD_MAIN_DETAILS_LOGBOOK_API = async () => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("date_time_log", logDate || "");
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("cyl_exhaust_temp_for_main", cyl_exhaust_temp_for_main);
      FORM_DATA.append(
        "cyl_scavenge_box_temp_for_main",
        cyl_scavenge_box_temp_for_main
      );
      FORM_DATA.append(
        "cyl_jacket_water_temp_for_main",
        cyl_jacket_water_temp_for_main
      );
      FORM_DATA.append(
        "cyl_piston_cooling_oil_out_temp_for_main",
        cyl_piston_cooling_oil_out_temp_for_main
      );
      FORM_DATA.append("cyl_fuel_rack_for_main", cyl_fuel_rack_for_main);
      FORM_DATA.append("fuel_oil_type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("fuel_index", Number(fuel_index) || 0);
      FORM_DATA.append("govenor", Number(govenor) || 0);
      FORM_DATA.append("pressure", pressure || "");
      FORM_DATA.append("fuel_oil_inlet_pressure", Number(fuel_oil_inlet) || 0);
      FORM_DATA.append("fuel_oil_inlet_temp", Number(fuel_oil_inlet_temp) || 0);
      FORM_DATA.append(
        "starting_air_pressure",
        Number(starting_air_pressure) || 0
      );
      FORM_DATA.append(
        "control_air_pressure",
        Number(control_air_pressure) || 0
      );
      FORM_DATA.append(
        "scavenge_air_inlet_temp",
        Number(scavenge_air_inlet_temp) || 0
      );
      FORM_DATA.append(
        "scavenge_air_pressure",
        Number(scavenge_air_pressure) || 0
      );
      FORM_DATA.append("egb_inlet_temp", Number(egb_inlet_temp) || 0);
      FORM_DATA.append("egb_outlet_temp", Number(egb_outlet_temp) || 0);
      FORM_DATA.append("rpm_x_1000", Number(rpm_X_1000) || 0);
      FORM_DATA.append("exhaust_in_temp", Number(exhaust_in_temp) || 0);
      FORM_DATA.append("exhaust_out_temp", Number(exhaust_out_temp) || 0);
      FORM_DATA.append("lube_oil_in_temp", Number(lube_oil_in_temp) || 0);
      FORM_DATA.append("lube_oil_out_temp", Number(lube_oil_out_temp) || 0);
      FORM_DATA.append(
        "lube_oil_in_pressure",
        Number(lube_oil_in_pressure) || 0
      );
      FORM_DATA.append(
        "lube_oil_out_pressure",
        Number(lube_oil_out_pressure) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_in_temp",
        Number(lo_cooling_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_in_pressure",
        Number(lo_cooling_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_out_temp",
        Number(lo_cooler_cooling_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_out_pressure",
        Number(lo_cooler_cooling_water_out_pressure) || 0
      );
      FORM_DATA.append(
        "lube_oil_inlet_temp_for_main",
        Number(lube_oil_inlet_to_engine) || 0
      );
      FORM_DATA.append(
        "lube_oil_inlet_to_tc",
        Number(lube_oil_inlet_to_tc) || 0
      );
      FORM_DATA.append("lube_oil_inlet_temp", Number(lube_oil_inlet_temp) || 0);
      FORM_DATA.append("ac_air_in_temp", Number(air_cooler_air_in_temp) || 0);
      FORM_DATA.append("ac_air_out_temp", Number(air_cooler_air_out_temp) || 0);
      FORM_DATA.append(
        "ac_cooling_water_in_temp",
        Number(ac_cooling_water_in_temp) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_out_temp",
        Number(ac_cooling_water_out_temp) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_in_pressure",
        Number(ac_cooling_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_out_pressure",
        Number(ac_cooling_water_out_pressure) || 0
      );
      FORM_DATA.append("ac_air_in_pressure", Number(ac_air_in_pressure) || 0);
      FORM_DATA.append("ac_air_out_pressure", Number(ac_air_out_pressure) || 0);
      FORM_DATA.append(
        "ac_manometer_pressure",
        Number(ac_manometer_pressure) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_in_temp",
        Number(lt_sea_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_out_temp",
        Number(lt_sea_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_in_pressure",
        Number(lt_sea_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_out_pressure",
        Number(lt_sea_water_out_pressure) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_in_temp",
        Number(lt_fresh_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_out_temp",
        Number(lt_fresh_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_in_pressure",
        Number(lt_fresh_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_out_pressure",
        Number(lt_fresh_water_out_pressure) || 0
      );
      FORM_DATA.append("main_engine_number", main_engine_number || "");
      FORM_DATA.append(
        "cooling_water_inlet_pressure",
        Number(cooling_water_inlet) || 0
      );
      FORM_DATA.append("air_cooler_air_in", Number(air_In) || 0);
      FORM_DATA.append("air_cooler_air_out", Number(air_Out) || 0);
      FORM_DATA.append("lube_oil_inlet_temp", Number(lube_Oil_Inlet) || 0);
      FORM_DATA.append("main_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "main_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append("main_comment", free_Text || "");
      FORM_DATA.append("cyl_oil_bn", Number(cyl_oil_bn) || 0);
      FORM_DATA.append("turbocharger_on_off", turbocharger_on_off || false);
      FORM_DATA.append("exhaust_in_temp_two", Number(exhaust_in_temp_two) || 0);
      FORM_DATA.append(
        "exhaust_out_temp_two",
        Number(exhaust_out_temp_two) || 0
      );
      FORM_DATA.append("rpm_X_1000_two", Number(rpm_X_1000_two) || 0);
      FORM_DATA.append("air_In_two", Number(air_In_two) || 0);
      FORM_DATA.append("air_Out_two", Number(air_Out_two) || 0);
      FORM_DATA.append(
        "lube_oil_inlet_to_tc_two",
        Number(lube_oil_inlet_to_tc_two) || 0
      );
      post(ApiURL.add_main_eng_log_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Logbook Add Success message!", res?.message);
          VIEW_MAIN_DETAILS_LOGBOOK_API(staff_dashboard);
          set_loader(false);
          set_errors({});
        } else {
          set_loader(false);
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    } finally {
    }
  };

  const UPDATE_MAIN_DETAILS_LOGBOOK_API = async (save_submit) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("date_time_log", logDate || "");
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("cyl_exhaust_temp_for_main", cyl_exhaust_temp_for_main);
      FORM_DATA.append(
        "cyl_scavenge_box_temp_for_main",
        cyl_scavenge_box_temp_for_main
      );
      FORM_DATA.append(
        "cyl_jacket_water_temp_for_main",
        cyl_jacket_water_temp_for_main
      );
      FORM_DATA.append(
        "cyl_piston_cooling_oil_out_temp_for_main",
        cyl_piston_cooling_oil_out_temp_for_main
      );
      FORM_DATA.append("cyl_fuel_rack_for_main", cyl_fuel_rack_for_main || 0);
      FORM_DATA.append("fuel_oil_type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("fuel_index", Number(fuel_index) || 0);
      FORM_DATA.append("govenor", Number(govenor) || 0);
      FORM_DATA.append("pressure", pressure || "");
      FORM_DATA.append("fuel_oil_inlet_pressure", Number(fuel_oil_inlet) || 0);
      FORM_DATA.append("fuel_oil_inlet_temp", Number(fuel_oil_inlet_temp) || 0);
      FORM_DATA.append(
        "starting_air_pressure",
        Number(starting_air_pressure) || 0
      );
      FORM_DATA.append(
        "control_air_pressure",
        Number(control_air_pressure) || 0
      );
      FORM_DATA.append(
        "scavenge_air_inlet_temp",
        Number(scavenge_air_inlet_temp) || 0
      );
      FORM_DATA.append(
        "scavenge_air_pressure",
        Number(scavenge_air_pressure) || 0
      );
      FORM_DATA.append("egb_inlet_temp", Number(egb_inlet_temp) || 0);
      FORM_DATA.append("egb_outlet_temp", Number(egb_outlet_temp) || 0);
      FORM_DATA.append("rpm_x_1000", Number(rpm_X_1000) || 0);
      FORM_DATA.append("exhaust_in_temp", Number(exhaust_in_temp) || 0);
      FORM_DATA.append("exhaust_out_temp", Number(exhaust_out_temp) || 0);
      FORM_DATA.append("lube_oil_in_temp", Number(lube_oil_in_temp) || 0);
      FORM_DATA.append("lube_oil_out_temp", Number(lube_oil_out_temp) || 0);
      FORM_DATA.append(
        "lube_oil_in_pressure",
        Number(lube_oil_in_pressure) || 0
      );
      FORM_DATA.append(
        "lube_oil_out_pressure",
        Number(lube_oil_out_pressure) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_in_temp",
        Number(lo_cooling_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_in_pressure",
        Number(lo_cooling_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_out_temp",
        Number(lo_cooler_cooling_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lo_cooling_water_out_pressure",
        Number(lo_cooler_cooling_water_out_pressure) || 0
      );
      FORM_DATA.append(
        "lube_oil_inlet_temp_for_main",
        Number(lube_oil_inlet_to_engine) || 0
      );
      FORM_DATA.append(
        "lube_oil_inlet_to_tc",
        Number(lube_oil_inlet_to_tc) || 0
      );
      FORM_DATA.append("lube_oil_inlet_temp", Number(lube_oil_inlet_temp) || 0);
      FORM_DATA.append("ac_air_in_temp", Number(air_cooler_air_in_temp) || 0);
      FORM_DATA.append("ac_air_out_temp", Number(air_cooler_air_out_temp) || 0);
      FORM_DATA.append(
        "ac_cooling_water_in_temp",
        Number(ac_cooling_water_in_temp) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_out_temp",
        Number(ac_cooling_water_out_temp) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_in_pressure",
        Number(ac_cooling_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "ac_cooling_water_out_pressure",
        Number(ac_cooling_water_out_pressure) || 0
      );
      FORM_DATA.append("ac_air_in_pressure", Number(ac_air_in_pressure) || 0);
      FORM_DATA.append("ac_air_out_pressure", Number(ac_air_out_pressure) || 0);
      FORM_DATA.append(
        "ac_manometer_pressure",
        Number(ac_manometer_pressure) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_in_temp",
        Number(lt_sea_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_out_temp",
        Number(lt_sea_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_in_pressure",
        Number(lt_sea_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lt_sea_water_out_pressure",
        Number(lt_sea_water_out_pressure) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_in_temp",
        Number(lt_fresh_water_in_temp) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_out_temp",
        Number(lt_fresh_water_out_temp) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_in_pressure",
        Number(lt_fresh_water_in_pressure) || 0
      );
      FORM_DATA.append(
        "lt_fresh_water_out_pressure",
        Number(lt_fresh_water_out_pressure) || 0
      );
      FORM_DATA.append("main_engine_number", Number(main_engine_number) || 0);
      FORM_DATA.append(
        "cooling_water_inlet_pressure",
        Number(cooling_water_inlet) || 0
      );
      FORM_DATA.append("air_cooler_air_in", Number(air_In) || 0);
      FORM_DATA.append("air_cooler_air_out", Number(air_Out) || 0);
      FORM_DATA.append("lube_oil_inlet_temp", Number(lube_Oil_Inlet) || 0);
      FORM_DATA.append("main_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "main_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append("main_comment", free_Text || "");
      FORM_DATA.append("cyl_oil_bn", Number(cyl_oil_bn) || 0);
      FORM_DATA.append("turbocharger_on_off", turbocharger_on_off || false);
      FORM_DATA.append("exhaust_in_temp_two", Number(exhaust_in_temp_two) || 0);
      FORM_DATA.append(
        "exhaust_out_temp_two",
        Number(exhaust_out_temp_two) || 0
      );
      FORM_DATA.append("rpm_X_1000_two", Number(rpm_X_1000_two) || 0);
      FORM_DATA.append("air_In_two", Number(air_In_two) || 0);
      FORM_DATA.append("air_Out_two", Number(air_Out_two) || 0);
      FORM_DATA.append(
        "lube_oil_inlet_to_tc_two",
        Number(lube_oil_inlet_to_tc_two) || 0
      );
      post(ApiURL.view_update_main_eng_log_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          SuccessToast("Logbook Update Success!", res?.message);
          VIEW_MAIN_DETAILS_LOGBOOK_API(staff_dashboard);
        } else {
          set_loader(false);
          ErrorToast(
            "Error message",
            "Submission failed! Please fill in all required fields and try again."
          );
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    } finally {
    }
  };

  const VIEW_MAIN_DETAILS_LOGBOOK_API = async (voyage_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);
      FORM_DATA.append("main_engine_number", main_engine_number);
      post(ApiURL.view_update_main_eng_log_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const main_engine = res?.response_data;
          set_update_status(main_engine?.complete_status);
          const cyl_exhaust_temp_for_mainArray =
            main_engine?.cyl_exhaust_temp_for_main
              ? main_engine?.cyl_exhaust_temp_for_main.split(",")
              : "";
          const cyl_scavenge_box_temp_for_mainArray =
            main_engine?.cyl_scavenge_box_temp_for_main
              ? main_engine?.cyl_scavenge_box_temp_for_main.split(",")
              : "";
          const cyl_jacket_water_temp_for_mainArray =
            main_engine?.cyl_jacket_water_temp_for_main
              ? main_engine?.cyl_jacket_water_temp_for_main.split(",")
              : "";
          const cyl_piston_cooling_oil_out_temp_for_mainArray =
            main_engine?.cyl_piston_cooling_oil_out_temp_for_main
              ? main_engine?.cyl_piston_cooling_oil_out_temp_for_main.split(",")
              : "";
          const cyl_fuel_rack_for_mainArray =
            main_engine?.cyl_fuel_rack_for_main
              ? main_engine?.cyl_fuel_rack_for_main.split(",")
              : "";

          set_cyl_exhaust_temp_for_main(
            main_engine?.cyl_exhaust_temp_for_main
              ? cyl_exhaust_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_scavenge_box_temp_for_main(
            main_engine?.cyl_scavenge_box_temp_for_main
              ? cyl_scavenge_box_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_jacket_water_temp_for_main(
            main_engine?.cyl_jacket_water_temp_for_main
              ? cyl_jacket_water_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_piston_cooling_oil_out_temp_for_main(
            main_engine?.cyl_piston_cooling_oil_out_temp_for_main
              ? cyl_piston_cooling_oil_out_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_fuel_rack_for_main(
            main_engine?.cyl_fuel_rack_for_main
              ? cyl_fuel_rack_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_Fuel_Oil_Type(main_engine?.fuel_oil_type);
          set_Other_fuel_oil_type(main_engine?.other_fuel_oil_type);
          set_fuel_index(main_engine?.fuel_index);
          set_govenor(main_engine?.govenor);
          set_fuel_oil_inlet_temp(main_engine?.fuel_oil_inlet_temp);
          set_pressure(main_engine?.pressure);
          set_starting_air_pressure(main_engine?.starting_air_pressure);
          set_control_air_pressure(main_engine?.control_air_pressure);
          set_scavenge_air_pressure(main_engine?.scavenge_air_pressure);
          set_Rpm_X_1000(main_engine?.rpm_x_1000);
          set_Air_In(main_engine?.air_cooler_air_in);
          set_Air_Out(main_engine?.air_cooler_air_out);
          set_lube_oil_in_temp(main_engine?.lube_oil_in_temp);
          set_lube_oil_out_temp(main_engine?.lube_oil_out_temp);
          set_lube_oil_in_pressure(main_engine?.lube_oil_in_pressure);
          set_lube_oil_out_pressure(main_engine?.lube_oil_out_pressure);
          set_lo_cooling_water_in_temp(main_engine?.lo_cooling_water_in_temp);
          set_lo_cooling_water_in_pressure(
            main_engine?.lo_cooling_water_in_pressure
          );
          set_lo_cooler_cooling_water_out_temp(
            main_engine?.lo_cooling_water_out_temp
          );
          set_lo_cooler_cooling_water_out_pressure(
            main_engine?.lo_cooling_water_out_pressure
          );
          set_lube_oil_inlet_to_tc(main_engine?.lube_oil_inlet_to_tc);
          set_ac_cooling_water_in_temp(main_engine?.ac_cooling_water_in_temp);
          set_ac_cooling_water_out_temp(main_engine?.ac_cooling_water_out_temp);
          set_ac_cooling_water_in_pressure(
            main_engine?.ac_cooling_water_in_pressure
          );
          set_ac_cooling_water_out_pressure(
            main_engine?.ac_cooling_water_out_pressure
          );
          set_ac_air_in_pressure(main_engine?.ac_air_in_pressure);
          set_ac_air_out_pressure(main_engine?.ac_air_out_pressure);
          set_ac_manometer_pressure(main_engine?.ac_manometer_pressure);
          set_lt_sea_water_in_temp(main_engine?.lt_sea_water_in_temp);
          set_lt_sea_water_out_temp(main_engine?.lt_sea_water_out_temp);
          set_lt_sea_water_in_pressure(main_engine?.lt_sea_water_in_pressure);
          set_lt_sea_water_out_pressure(main_engine?.lt_sea_water_out_pressure);
          set_lt_fresh_water_in_temp(main_engine?.lt_fresh_water_in_temp);
          set_lt_fresh_water_out_temp(main_engine?.lt_fresh_water_out_temp);
          set_lt_fresh_water_in_pressure(
            main_engine?.lt_fresh_water_in_pressure
          );
          set_lt_fresh_water_out_pressure(
            main_engine?.lt_fresh_water_out_pressure
          );
          // set_main_engine_number(main_engine?.main_engine_number);
          set_cooling_water_inlet(main_engine?.cooling_water_inlet_pressure);
          set_scavenge_air_inlet_temp(main_engine?.scavenge_air_inlet_temp);
          set_lube_oil_inlet_temp(main_engine?.lube_oil_inlet_temp);
          set_egb_inlet_temp(main_engine?.egb_inlet_temp);
          set_egb_outlet_temp(main_engine?.egb_outlet_temp);
          set_exhaust_in_temp(main_engine?.exhaust_in_temp);
          set_exhaust_out_temp(main_engine?.exhaust_out_temp);
          set_air_cooler_air_in_temp(main_engine?.ac_air_in_temp);
          set_air_cooler_air_out_temp(main_engine?.ac_air_out_temp);
          set_fuel_oil_inlet(main_engine?.fuel_oil_inlet_pressure);
          set_Lube_Oil_Inlet(main_engine?.lube_oil_inlet_temp);
          set_lube_oil_inlet_to_engine(
            main_engine?.lube_oil_inlet_temp_for_main
          );
          set_Running_Hour(main_engine?.main_running_hours);
          set_Total_Running_Hour(main_engine?.main_total_running_hours);
          set_Free_Text(main_engine?.main_comment);
          setSubmitStatus(res?.submit_status);
          set_LogDate(main_engine?.date_time_log);
          set_cyl_oil_bn(main_engine?.cyl_oil_bn);
          set_turbocharger_on_off(main_engine?.turbocharger_on_off);
          set_exhaust_in_temp_two(main_engine?.exhaust_in_temp_two);
          set_exhaust_out_temp_two(main_engine?.exhaust_out_temp_two);
          set_Rpm_X_1000_two(main_engine?.rpm_X_1000_two);
          set_Air_In_two(main_engine?.air_In_two);
          set_Air_Out_two(main_engine?.air_Out_two);
          set_lube_oil_inlet_to_tc_two(main_engine?.lube_oil_inlet_to_tc_two);
          set_ship_no_of_cylinder(res?.main_eng_cylinder);
          set_engine_number_list(res?.main_Engine_numbers);
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error View logbook:", error);
    }
  };

  useEffect(() => {
    if (turbocharger_on_off == false) {
      set_exhaust_in_temp_two("");
      set_exhaust_out_temp_two("");
      set_Rpm_X_1000_two("");
      set_Air_In_two("");
      set_Air_Out_two("");
      set_lube_oil_inlet_to_tc_two("");
    }
  }, [turbocharger_on_off]);

  // useEffect(() => {
  //   const local_user = JSON.parse(localStorage.getItem("user_data"));
  //   const engine_Number = local_user?.data?.ship_details?.number_of_main_engine;
  //   if (engine_Number) {
  //     const engineArray = Array.from({ length: engine_Number }, (_, i) => i + 1);
  //     set_engine_number_list(engineArray);
  //   } else {
  //     set_engine_number_list([]);
  //   }
  // }, []);

  useEffect(() => {
    const voyageId = staff_dashboard?.voyage_details?.[0]?.id;
    if (voyageId && main_engine_number) {
      VIEW_MAIN_DETAILS_LOGBOOK_API(staff_dashboard);
    }
  }, [main_engine_number]);

  useEffect(() => {
    const local_user = JSON.parse(localStorage.getItem("user_data"));
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_ship_no_of_cylinder(local_user?.data?.ship_details?.no_of_cylinder);
    set_staff_dashboard(parsedData);
    if (parsedData && eng_log_basic_id) {
      VIEW_MAIN_DETAILS_LOGBOOK_API(parsedData);
    }
    ALARM_VIEW_API();
  }, []);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  return (
    <>
      <div className="white-container">
        <>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Main Engine Number</label>
                <Select
                  disabled={submitStatus}
                  value={main_engine_number}
                  placeholder=" -- Select of Main Engine Number  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => {
                    set_main_engine_number(value);
                  }}
                >
                  {engine_number_list?.map((number) => (
                    <Select.Option key={number} value={number}>
                      {number}
                    </Select.Option>
                  ))}
                </Select>
                {errors?.main_engine_number && (
                  <span style={{ color: "red" }}>
                    {errors?.main_engine_number}
                  </span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Date & Time</label>

                <DatePicker
                  disabled
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={
                    update_status && logDate
                      ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss")
                      : selectedDate
                      ? dayjs(selectedDate, "YYYY-MM-DD HH:mm:ss")
                      : null
                  }
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                />

                {errors.date_time_log && (
                  <p className="error-text">{errors.date_time_log}</p>
                )}
              </div>
            </div>
          </div>
          {/* CYL Exhaust Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>CYL Exhaust Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    input_number={ship_no_of_cylinder}
                    disabled={submitStatus}
                    set_value={set_cyl_exhaust_temp_for_main}
                    values={cyl_exhaust_temp_for_main}
                    alarm_Data={main_exhaust_temp}
                  />
                </div>
                {errors?.cyl_exhaust_temp_for_main && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.cyl_exhaust_temp_for_main}
                    </span>
                  </>
                )}
              </div>
            </div>
            {/* Scavenge Box Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Box Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    input_number={ship_no_of_cylinder}
                    disabled={submitStatus}
                    set_value={set_cyl_scavenge_box_temp_for_main}
                    values={cyl_scavenge_box_temp_for_main}
                    alarm_Data={scavenge_box_temp}
                  />
                </div>
                {errors?.cyl_scavenge_box_temp_for_main && (
                  <span style={{ color: "red" }}>
                    {errors?.cyl_scavenge_box_temp_for_main}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Jacket Water Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Jacket Water Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    input_number={ship_no_of_cylinder}
                    disabled={submitStatus}
                    set_value={set_cyl_jacket_water_temp_for_main}
                    values={cyl_jacket_water_temp_for_main}
                    alarm_Data={jacket_water_temp}
                  />
                </div>
                {errors?.cyl_jacket_water_temp_for_main && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.cyl_jacket_water_temp_for_main}
                    </span>
                  </>
                )}
              </div>
            </div>
            {/* Fuel Rack */}
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Rack</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Rack"
                    input_number={ship_no_of_cylinder}
                    disabled={submitStatus}
                    set_value={set_cyl_fuel_rack_for_main}
                    values={cyl_fuel_rack_for_main}
                    alarm_Data={fuel_rack}
                  />
                </div>
                {errors?.cyl_fuel_rack_for_main && (
                  <span style={{ color: "red" }}>
                    {errors?.cyl_fuel_rack_for_main}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Piston Cooling Oil Out Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Piston Cooling Oil Out Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    input_number={ship_no_of_cylinder}
                    disabled={submitStatus}
                    set_value={set_cyl_piston_cooling_oil_out_temp_for_main}
                    values={cyl_piston_cooling_oil_out_temp_for_main}
                    alarm_Data={piston_cooling_oil_out_temp}
                  />
                </div>
                {errors?.cyl_piston_cooling_oil_out_temp_for_main && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.cyl_piston_cooling_oil_out_temp_for_main}
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>CYL oil BN</label>
                <Input
                  disabled={submitStatus}
                  value={cyl_oil_bn}
                  placeholder="CYL oil BN"
                  onChange={(e) => set_cyl_oil_bn(e.target.value)}
                />
                {errors?.cyl_oil_bn && (
                  <span style={{ color: "red" }}>{errors?.cyl_oil_bn}</span>
                )}
              </div>
            </div>
          </div>

          {/* Running Hour */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Running Hour</label>
                <Input
                  disabled={submitStatus}
                  value={running_Hour}
                  placeholder="Running Hour "
                  onChange={(e) => set_Running_Hour(e.target.value)}
                />

                {errors?.main_running_hours && (
                  <span style={{ color: "red" }}>
                    {errors?.main_running_hours}
                  </span>
                )}
              </div>
            </div>
            {/* Total Running Hour */}
            <div className="col-6">
              <div className="input-box">
                <label>Total Running Hour</label>
                <Input
                  disabled={submitStatus}
                  value={total_Running_Hour}
                  placeholder="Total Running Hour"
                  onChange={(e) => {
                    set_Total_Running_Hour(e.target.value);
                  }}
                />
                {errors?.main_total_running_hours && (
                  <span style={{ color: "red" }}>
                    {errors?.main_total_running_hours}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Fuel index */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fuel index</label>
                <Input
                  disabled={submitStatus}
                  value={fuel_index}
                  placeholder="Fuel index"
                  onChange={(e) => set_fuel_index(e.target.value)}
                />
                {errors?.fuel_index && (
                  <span style={{ color: "red" }}>{errors?.fuel_index}</span>
                )}
              </div>
            </div>
            {/* Governor */}
            <div className="col-6">
              <div className="input-box">
                <label>Governor load</label>
                <Input
                  disabled={submitStatus}
                  value={govenor}
                  placeholder="Governor load"
                  onChange={(e) => {
                    set_govenor(e.target.value);
                  }}
                />
                {errors?.govenor && (
                  <span style={{ color: "red" }}>{errors?.govenor}</span>
                )}
              </div>
            </div>
          </div>

          {/* Fuel oil inlet  */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Pressure</label>
                <Select
                  disabled={submitStatus}
                  value={pressure}
                  placeholder=" -- Select of Pressure  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => set_pressure(value)}
                >
                  <Select.Option value="Bar">Bar</Select.Option>
                  <Select.Option value="Pascal">Pascal</Select.Option>
                </Select>
                {errors?.pressure && (
                  <span style={{ color: "red" }}>{errors?.pressure}</span>
                )}
              </div>
            </div>
            {/* Fuel Oil Inlet Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Oil Inlet Temp (°C)</label>

                <AlramInput
                  disabled={submitStatus}
                  value={fuel_oil_inlet_temp}
                  placeholder="Fuel Oil Inlet Temp (°C)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(fuel_oil_inlet_alarm?.max)) return;
                    set_fuel_oil_inlet_temp(e.target.value);
                  }}
                  alarm_Data={fuel_oil_inlet_alarm}
                />
                {errors?.fuel_oil_inlet_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.fuel_oil_inlet_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fuel oil inlet Pressure (Bar)</label>
                <AlramInput
                  disabled={submitStatus}
                  value={fuel_oil_inlet}
                  placeholder="Fuel oil inlet Pressure (Bar)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(fuel_oil_inlet_to_engine?.max))
                      return;
                    set_fuel_oil_inlet(newValue);
                  }}
                  alarm_Data={fuel_oil_inlet_to_engine}
                />
                {errors?.fuel_oil_inlet_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.fuel_oil_inlet_pressure}
                  </span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Oil Type</label>
                <Select
                  disabled={submitStatus}
                  value={fuel_Oil_Type}
                  placeholder=" -- Select of  Fuel Oil Type  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => set_Fuel_Oil_Type(value)}
                >
                  <Select.Option value="VLSFO">VLSFO</Select.Option>
                  <Select.Option value="LSMGO">LSMGO</Select.Option>
                  <Select.Option value="HSFO">HSFO</Select.Option>
                  <Select.Option value="Other">Other</Select.Option>
                </Select>
                {errors?.fuel_oil_type && (
                  <span style={{ color: "red" }}>{errors?.fuel_oil_type}</span>
                )}
              </div>
            </div>
          </div>
          {fuel_Oil_Type === "Other" && (
            <div className="row">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="input-box">
                  <label>Other fuel oil type</label>
                  <Input
                    disabled={submitStatus}
                    value={other_fuel_oil_type}
                    placeholder="Other fuel oil type"
                    onChange={(e) => {
                      set_Other_fuel_oil_type(e.target.value);
                    }}
                  />
                  {errors?.other_fuel_oil_type && (
                    <span style={{ color: "red" }}>
                      {errors?.other_fuel_oil_type}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>LO inlet Pr to Engine</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_inlet_to_engine}
                  placeholder="LO inlet Pr to Engine"
                  onChange={(e) => set_lube_oil_inlet_to_engine(e.target.value)}
                />
                {errors?.lube_oil_inlet_temp_for_main && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_inlet_temp_for_main}
                  </span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>LO temp inlet to Main engine</label>
                <AlramInput
                  disabled={submitStatus}
                  value={lube_Oil_Inlet}
                  placeholder="LO temp inlet to Main engine"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(lube_oil_inlet?.max)) return;
                    set_Lube_Oil_Inlet(e.target.value);
                  }}
                  alarm_Data={lube_oil_inlet}
                />
                {errors?.lube_oil_inlet_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_inlet_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Starting Air Pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Starting Air Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={starting_air_pressure}
                  placeholder="Starting air pressure (Bar)"
                  onChange={(e) => {
                    set_starting_air_pressure(e.target.value);
                  }}
                />
                {errors?.starting_air_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.starting_air_pressure}
                  </span>
                )}
              </div>
            </div>
            {/* Control Air Pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Control Air Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={control_air_pressure}
                  placeholder="Control Air Pressure (Bar)"
                  onChange={(e) => set_control_air_pressure(e.target.value)}
                />
                {errors?.control_air_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.control_air_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Scavenge Air Inlet Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Air Inlet Temp</label>
                <AlramInput
                  disabled={submitStatus}
                  value={scavenge_air_inlet_temp}
                  placeholder="Scavenge Air Inlet Temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(scavenge_air_inlet?.max)) return;
                    set_scavenge_air_inlet_temp(e.target.value);
                  }}
                  alarm_Data={scavenge_air_inlet}
                />
                {errors?.scavenge_air_inlet_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.scavenge_air_inlet_temp}
                  </span>
                )}
              </div>
            </div>
            {/* Scavenge Air Pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Air Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={scavenge_air_pressure}
                  placeholder="Scavenge air pressure (Bar)"
                  onChange={(e) => set_scavenge_air_pressure(e.target.value)}
                />
                {errors?.scavenge_air_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.scavenge_air_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Egb Inlet Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>EGB Inlet Temp</label>

                <AlramInput
                  disabled={submitStatus}
                  value={egb_inlet_temp}
                  placeholder=" EGB Inlet temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(egb_inlet?.max)) return;
                    set_egb_inlet_temp(e.target.value);
                  }}
                  alarm_Data={egb_inlet}
                />

                {errors?.egb_inlet_temp && (
                  <span style={{ color: "red" }}>{errors?.egb_inlet_temp}</span>
                )}
              </div>
            </div>
            {/* EGB Outlet Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>EGB Outlet Temp</label>

                <AlramInput
                  disabled={submitStatus}
                  value={egb_outlet_temp}
                  placeholder="EGB Outlet temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(egb_outlet?.max)) return;
                    set_egb_outlet_temp(e.target.value);
                  }}
                  alarm_Data={egb_outlet}
                />
                {errors?.egb_outlet_temp && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.egb_outlet_temp}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>

          <h3>Turbocharger Number 1</h3>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Exhaust In Temp (°C)</label>

                <AlramInput
                  disabled={submitStatus}
                  value={exhaust_in_temp}
                  placeholder="Exhaust in Temp (°C)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(exh_in?.max)) return;
                    set_exhaust_in_temp(e.target.value);
                  }}
                  alarm_Data={exh_in}
                />
                {errors?.exhaust_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.exhaust_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/* Exhaust  Out Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>Exhaust Out Temp (°C)</label>
                <AlramInput
                  disabled={submitStatus}
                  value={exhaust_out_temp}
                  placeholder="Exhaust Out temp (°C)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(exh_out?.max)) return;
                    set_exhaust_out_temp(e.target.value);
                  }}
                  alarm_Data={exh_out}
                />
                {errors?.exhaust_out_temp && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.exhaust_out_temp}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>RPM X 1000</label>
                <Input
                  disabled={submitStatus}
                  value={rpm_X_1000}
                  placeholder="rpm X 1000"
                  onChange={(e) => {
                    set_Rpm_X_1000(e.target.value);
                  }}
                />
                {errors?.rpm_x_1000 && (
                  <span style={{ color: "red" }}>{errors?.rpm_x_1000}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Inlet To TC (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_inlet_to_tc}
                  placeholder="Inlet To TC (°C)"
                  onChange={(e) => set_lube_oil_inlet_to_tc(e.target.value)}
                />
                {errors?.lube_oil_inlet_to_tc && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.lube_oil_inlet_to_tc}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row" style={{ padding: "10px" }}>
            <h3>Turbocharger Number 2</h3>
            <Switch
              disabled={submitStatus}
              value={turbocharger_on_off}
              onChange={(value) => {
                set_turbocharger_on_off(value);
              }}
              checkedChildren="On"
              unCheckedChildren="Off"
              style={{
                backgroundColor: turbocharger_on_off ? "green" : "red",
                marginLeft: "10px",
              }}
            />
          </div>
          {turbocharger_on_off && (
            <>
              <div className="row">
                <div className="col-6">
                  <div className="input-box">
                    <label>Exhaust In Temp (°C)</label>

                    <AlramInput
                      disabled={submitStatus}
                      value={exhaust_in_temp_two}
                      placeholder="Exhaust in Temp (°C)"
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (newValue > Number(exh_in?.max)) return;
                        set_exhaust_in_temp_two(e.target.value);
                      }}
                      alarm_Data={exh_in}
                    />
                    {errors?.exhaust_in_temp_two && (
                      <span style={{ color: "red" }}>
                        {errors?.exhaust_in_temp_two}
                      </span>
                    )}
                  </div>
                </div>
                {/* Exhaust  Out Temp*/}
                <div className="col-6">
                  <div className="input-box">
                    <label>Exhaust Out Temp (°C)</label>
                    <AlramInput
                      disabled={submitStatus}
                      value={exhaust_out_temp_two}
                      placeholder="Exhaust Out temp (°C)"
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (newValue > Number(exh_out?.max)) return;
                        set_exhaust_out_temp_two(e.target.value);
                      }}
                      alarm_Data={exh_out}
                    />
                    {errors?.exhaust_out_temp_two && (
                      <>
                        <span style={{ color: "red" }}>
                          {errors?.exhaust_out_temp_two}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <div className="input-box">
                    <label>RPM X 1000</label>
                    <Input
                      disabled={submitStatus}
                      value={rpm_X_1000_two}
                      placeholder="rpm X 1000"
                      onChange={(e) => {
                        set_Rpm_X_1000_two(e.target.value);
                      }}
                    />
                    {errors?.rpm_X_1000_two && (
                      <span style={{ color: "red" }}>
                        {errors?.rpm_X_1000_two}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-6">
                  <div className="input-box">
                    <label>Inlet To TC (°C)</label>
                    <Input
                      disabled={submitStatus}
                      value={lube_oil_inlet_to_tc_two}
                      placeholder="Inlet To TC (°C)"
                      onChange={(e) =>
                        set_lube_oil_inlet_to_tc_two(e.target.value)
                      }
                    />
                    {errors?.lube_oil_inlet_to_tc_two && (
                      <>
                        <span style={{ color: "red" }}>
                          {errors?.lube_oil_inlet_to_tc_two}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          <h3>Lube Oil Cooler</h3>
          <div className="row">
            {/*Lube oil in Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>In Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_in_temp}
                  placeholder="In Temp (°C)"
                  onChange={(e) => {
                    set_lube_oil_in_temp(e.target.value);
                  }}
                />
                {errors?.lube_oil_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/* Lube oil out Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>Out Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_out_temp}
                  placeholder="Out Temp (°C)"
                  onChange={(e) => {
                    set_lube_oil_out_temp(e.target.value);
                  }}
                />
                {errors?.lube_oil_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_out_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            {/* lube oil in pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>In pressure (bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_in_pressure}
                  placeholder="In Pressure (bar)"
                  onChange={(e) => {
                    set_lube_oil_in_pressure(e.target.value);
                  }}
                />
                {errors?.lube_oil_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_in_pressure}
                  </span>
                )}
              </div>
            </div>
            {/* lube oil out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Out pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lube_oil_out_pressure}
                  placeholder="Out pressure (Bar)"
                  onChange={(e) => {
                    set_lube_oil_out_pressure(e.target.value);
                  }}
                />
                {errors?.lube_oil_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            {/*Lo cooling water in Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lo_cooling_water_in_temp}
                  placeholder="Cooling water in Temp (°C)"
                  onChange={(e) => {
                    set_lo_cooling_water_in_temp(e.target.value);
                  }}
                />
                {errors?.lo_cooling_water_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lo_cooling_water_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/* lo cooling water in pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lo_cooling_water_in_pressure}
                  placeholder="Cooling water in pressure (Bar)"
                  onChange={(e) => {
                    set_lo_cooling_water_in_pressure(e.target.value);
                  }}
                />
                {errors?.lo_cooling_water_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lo_cooling_water_in_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/*Lo cooler cooling water out Temp*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lo_cooler_cooling_water_out_temp}
                  placeholder="Cooling water out temp (°C)"
                  onChange={(e) => {
                    set_lo_cooler_cooling_water_out_temp(e.target.value);
                  }}
                />
                {errors?.lo_cooling_water_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lo_cooling_water_out_temp}
                  </span>
                )}
              </div>
            </div>
            {/* lo cooler cooling water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lo_cooler_cooling_water_out_pressure}
                  placeholder="Cooling water out pressure (Bar)"
                  onChange={(e) => {
                    set_lo_cooler_cooling_water_out_pressure(e.target.value);
                  }}
                />
                {errors?.lo_cooling_water_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lo_cooling_water_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          <h3>Air Cooler</h3>
          {/*  ac Air In Temp  */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Air In Temp</label>
                {/* <Input
                  disabled={submitStatus}
                  value={air_cooler_air_in_temp}
                  placeholder=" Air In temp"
                  onChange={(e) => {
                    set_air_cooler_air_in_temp(e.target.value);
                  }}
                /> */}
                <AlramInput
                  disabled={submitStatus}
                  value={air_cooler_air_in_temp}
                  placeholder=" Air In temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(air_cooler_air_in_temp?.max)) return;
                    set_air_cooler_air_in_temp(e.target.value);
                  }}
                  alarm_Data={air_in}
                />
                {errors?.ac_air_in_temp && (
                  <span style={{ color: "red" }}>{errors?.ac_air_in_temp}</span>
                )}
              </div>
            </div>
            {/*  ac Air out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Air Out Temp</label>
                {/* <Input
                  disabled={submitStatus}
                  value={air_cooler_air_out_temp}
                  placeholder=" Air Out Temp"
                  onChange={(e) => {
                    set_air_cooler_air_out_temp(e.target.value);
                  }}
                /> */}
                <AlramInput
                  disabled={submitStatus}
                  value={air_cooler_air_out_temp}
                  placeholder=" Air Out Temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(air_cooler_air_out_temp?.max)) return;
                    set_air_cooler_air_out_temp(e.target.value);
                  }}
                  alarm_Data={air_out}
                />
                {errors?.ac_air_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_air_out_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/*ac cooling water in Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={ac_cooling_water_in_temp}
                  placeholder="Cooling water in temp (°C)"
                  onChange={(e) => {
                    set_ac_cooling_water_in_temp(e.target.value);
                  }}
                />
                {errors?.ac_cooling_water_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_cooling_water_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/* ac Cooling Water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling Water out Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={ac_cooling_water_out_temp}
                  placeholder="Cooling water out temp (°C)"
                  onChange={(e) => {
                    set_ac_cooling_water_out_temp(e.target.value);
                  }}
                />
                {errors?.ac_cooling_water_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_cooling_water_out_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/*Ac cooling water In pressure*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={ac_cooling_water_in_pressure}
                  placeholder="Cooling water in pressure (Bar)"
                  onChange={(e) => {
                    set_ac_cooling_water_in_pressure(e.target.value);
                  }}
                />
                {errors?.ac_cooling_water_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_cooling_water_in_pressure}
                  </span>
                )}
              </div>
            </div>
            {/*Ac cooling water out pressure*/}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={ac_cooling_water_out_pressure}
                  placeholder="Cooling water out pressure (Bar)"
                  onChange={(e) => {
                    set_ac_cooling_water_out_pressure(e.target.value);
                  }}
                />
                {errors?.ac_cooling_water_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_cooling_water_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* ac air in pressure*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Air in Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={ac_air_in_pressure}
                  placeholder="Air in pressure (Bar)"
                  onChange={(e) => {
                    set_ac_air_in_pressure(e.target.value);
                  }}
                />
                {errors?.ac_air_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_air_in_pressure}
                  </span>
                )}
              </div>
            </div>
            {/*ac air out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Air Out Pressure</label>
                <Input
                  disabled={submitStatus}
                  value={ac_air_out_pressure}
                  placeholder=" air out pressure "
                  onChange={(e) => {
                    set_ac_air_out_pressure(e.target.value);
                  }}
                />
                {errors?.ac_air_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_air_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* ac manometer pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Manometer Pressure</label>
                <Input
                  disabled={submitStatus}
                  value={ac_manometer_pressure}
                  placeholder=" manometer pressure "
                  onChange={(e) => {
                    set_ac_manometer_pressure(e.target.value);
                  }}
                />
                {errors?.ac_manometer_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.ac_manometer_pressure}
                  </span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Cooling Water Inlet (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={cooling_water_inlet}
                  placeholder="Cooling water inlet (Bar)"
                  onChange={(e) => {
                    set_cooling_water_inlet(e.target.value);
                  }}
                />
                {errors?.ac_air_in_temp && (
                  <span style={{ color: "red" }}>{errors?.ac_air_in_temp}</span>
                )}
              </div>
            </div>
          </div>

          <h3>Low Temperature</h3>
          <div className="row">
            {/*Lt sea water in Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water In Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_sea_water_in_temp}
                  placeholder="Sea Water In Temp (°C)"
                  onChange={(e) => {
                    set_lt_sea_water_in_temp(e.target.value);
                  }}
                />
                {errors?.lt_sea_water_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_sea_water_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/*Lt sea water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water Out Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_sea_water_out_temp}
                  placeholder="Sea Water Out Temp (°C)"
                  onChange={(e) => {
                    set_lt_sea_water_out_temp(e.target.value);
                  }}
                />
                {errors?.lt_sea_water_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_sea_water_out_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Lt sea water in pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water In Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_sea_water_in_pressure}
                  placeholder="Sea Water In Pressure (Bar)"
                  onChange={(e) => {
                    set_lt_sea_water_in_pressure(e.target.value);
                  }}
                />
                {errors?.lt_sea_water_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_sea_water_in_pressure}
                  </span>
                )}
              </div>
            </div>
            {/* Lt sea water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water Out Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_sea_water_out_pressure}
                  placeholder="Sea Water Out Pressure (Bar)"
                  onChange={(e) => {
                    set_lt_sea_water_out_pressure(e.target.value);
                  }}
                />
                {errors?.lt_sea_water_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_sea_water_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Lt fresh water in Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water In Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_fresh_water_in_temp}
                  placeholder="Fresh Water In Temp (°C)"
                  onChange={(e) => {
                    set_lt_fresh_water_in_temp(e.target.value);
                  }}
                />
                {errors?.lt_fresh_water_in_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_fresh_water_in_temp}
                  </span>
                )}
              </div>
            </div>
            {/*Lt fresh water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water Out Temp (°C)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_fresh_water_out_temp}
                  placeholder="Fresh Water Out Temp (°C)"
                  onChange={(e) => {
                    set_lt_fresh_water_out_temp(e.target.value);
                  }}
                />
                {errors?.lt_fresh_water_out_temp && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_fresh_water_out_temp}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Lt fresh water in pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water In Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_fresh_water_in_pressure}
                  placeholder="Fresh Water In Pressure (Bar)"
                  onChange={(e) => {
                    set_lt_fresh_water_in_pressure(e.target.value);
                  }}
                />
                {errors?.lt_fresh_water_in_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_fresh_water_in_pressure}
                  </span>
                )}
              </div>
            </div>
            {/* Lt fresh water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water Out Pressure (Bar)</label>
                <Input
                  disabled={submitStatus}
                  value={lt_fresh_water_out_pressure}
                  placeholder="Fresh Water Out Pressure (Bar)"
                  onChange={(e) => {
                    set_lt_fresh_water_out_pressure(e.target.value);
                  }}
                />
                {errors?.lt_fresh_water_out_pressure && (
                  <span style={{ color: "red" }}>
                    {errors?.lt_fresh_water_out_pressure}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Main Engine Comments</label>
                <TextArea
                  rows={6}
                  placeholder="Main Engine Comments"
                  maxLength={1000}
                  disabled={submitStatus}
                  value={free_Text}
                  onChange={(e) => set_Free_Text(e.target.value)}
                />
                {errors?.main_comment && (
                  <span style={{ color: "red" }}>{errors?.main_comment}</span>
                )}
              </div>
            </div>
          </div>
        </>

        <div className="row">
          {user?.data?.designation === "Chief Engineer" && eng_log_basic_id && (
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                disabled={submitStatus}
                loading={loader}
                className="save_btn"
                style={{ color: "white" }}
                onClick={
                  update_status
                    ? () => UPDATE_MAIN_DETAILS_LOGBOOK_API("1")
                    : () => ADD_MAIN_DETAILS_LOGBOOK_API()
                }
              >
                Submit
              </Button>
            </div>
          )}
          <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              loading={loader}
              disabled={submitStatus}
              type="primary"
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={
                update_status
                  ? () => UPDATE_MAIN_DETAILS_LOGBOOK_API("0")
                  : () => ADD_MAIN_DETAILS_LOGBOOK_API()
              }
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainEngineLog;
